import { EmptyStateProps } from 'owa-empty-state/lib/components/EmptyState';
import { getIsLightBaseTheme } from 'owa-theme';
import {
    getRefreshSuggestionMessage,
    getPrimaryErrorMessage,
    FailureType,
} from 'owa-calendar-load-error-message';

/**
 * initialize the svgs icons
 */
let ERROR_STATE;

function initializeDisplayIconsForEmptyList() {
    if (getIsLightBaseTheme()) {
        // colored svgs that goes with the blue base theme
        ERROR_STATE = require('owa-empty-state/lib/svg/colored/loadingError.svg');
    } else {
        // gray scale svgs
        ERROR_STATE = require('owa-empty-state/lib/svg/gray/loadingError.svg');
    }
}

export function getErrorEmptyStateProps(failureType: FailureType): EmptyStateProps {
    initializeDisplayIconsForEmptyList();
    const primaryTextError = getPrimaryErrorMessage();
    const secondaryText = getRefreshSuggestionMessage(failureType);
    return {
        icon: ERROR_STATE,
        detailMessage: secondaryText,
        mainMessage: primaryTextError,
    };
}
